import { useEffect, useRef } from 'react';

export function useFilterButtonRefs(filters: string[]) {
  const itemsRef = useRef({});

  useEffect(() => {
    itemsRef.current = filters.reduce((acc, num) => {
      if (acc[num]) {
        return acc;
      }
      return { ...acc, [num]: null };
    }, {});
  }, [filters.join('')]);

  return {
    setInputRef: (fieldId: string) => (ref: any) =>
      (itemsRef.current[fieldId] = ref),
    getInputRef: (fieldId: string) => itemsRef.current[fieldId],
  };
}
